/*global angular*/
module.exports = ['curriculumManager', '$state', '$sessionStorage',
  function (curriculumManager, $state, $sessionStorage) {
    'use strict';
    return {
      restrict: 'E',
      template: require('./referenceButton.html'),
      replace: true,
      transclude: true,
      scope: {
        content: '=data'
      },
      link: function (scope) {
        scope.openRelation = async function () {
          const references = scope.content.$$relationsFrom
            .filter(r => r.$$expanded.relationtype === 'REFERENCES')
            .map(r => r.$$expanded);
          let curriculum;
          for (const reference of references) {
            const item = await curriculumManager.getByHref(reference.to.href);
            if (item) {
              if (item.type === 'CURRICULUM_ZILL') {
                $state.go('leerinhoud.overview');
              } else {
                $state.go('leerinhoud.field', { fieldKey: item.code });
              }
            } else {
              if (!curriculum) {
                curriculum = await curriculumManager.getCurriculum();
              }
              if (curriculum.$$meta.permalink === reference.to.href) {
                if (scope.content.key === '61d863ab-bbd1-455c-9f37-af724d4ea9c8') {
                  $sessionStorage.leerinhoudView = 'lijst';
                } else {
                  $sessionStorage.leerinhoudView = 'tegel';
                }
                $state.go('leerinhoud.overview');
              }
            }
          }
        };
      }
    };
  }
];




// WEBPACK FOOTER //
// ./web/js/module/visionText/js/referenceButton/referenceButton.js